import React, {
  useState,
  useEffect,
  useImperativeHandle,
  forwardRef,
  useCallback,
} from "react";

const CustomWizard = forwardRef(({ steps }, ref) => {
  const [currentStep, setCurrentStep] = useState(0);
  const [completed, setCompleted] = useState([]);

  const handleNext = useCallback(() => {
    if (currentStep < steps.length - 1) {
      setCurrentStep((prev) => {
        setCompleted((old) => [...old, prev]);
        return prev + 1;
      });
    }
  }, [currentStep, steps.length]);

  const handlePrev = useCallback(() => {
    if (currentStep > 0) {
      setCurrentStep((prev) => prev - 1);
      setCompleted((prev) => prev.filter((step) => step !== currentStep - 1));
    }
  }, [currentStep]);

  // Expondo métodos de navegação via ref
  useImperativeHandle(
    ref,
    () => ({
      nextStep: handleNext,
      previousStep: handlePrev,
      goToStep: (step) => {
        setCurrentStep(step);
        setCompleted((prev) => [...prev, step - 1]);
      },
      getCurrentStep: () => currentStep,
    }),
    [handleNext, handlePrev]
  );

  // Criando um novo array de steps com as funções de navegação injetadas
  const currentStepComponent = React.useMemo(() => {
    const currentComponent = steps[currentStep].component;
    return React.cloneElement(currentComponent, {
      onNext: handleNext,
      onPrevious: handlePrev,
      currentStep,
      totalSteps: steps.length,
    });
  }, [currentStep, steps, handleNext, handlePrev]);

  // Renderização dos indicadores de progresso
  const renderProgressIndicators = () => (
    <div className="step-progress">
      {/* Linhas de conexão */}
      <div className="step-connections">
        {steps.map(
          (_, index) =>
            index < steps.length - 1 && (
              <div
                key={`connection-${index}`}
                className={`step-connection ${
                  index < currentStep ? "completed" : ""
                }`}
              />
            )
        )}
      </div>

      {/* Círculos dos steps */}
      <div className="step-circles">
        {steps.map((step, index) => (
          <div key={index} className="step-item">
            <div
              className={`step-circle ${
                index === currentStep ? "active" : ""
              } ${index < currentStep ? "completed" : ""}`}
            >
              {index < currentStep ? (
                <i className="fa fa-check"></i>
              ) : (
                <span>{index + 1}</span>
              )}
            </div>
            <div
              className={`step-label ${index === currentStep ? "active" : ""}`}
            >
              {step.name}
            </div>
          </div>
        ))}
      </div>
    </div>
  );

  return (
    <div className="wizard-container">
      {renderProgressIndicators()}

      {/* Conteúdo do step atual */}
      <div className="step-content">{currentStepComponent}</div>
    </div>
  );
});

export default CustomWizard;
